import { render, staticRenderFns } from "./addText.vue?vue&type=template&id=09ca91ac&scoped=true&"
import script from "./addText.vue?vue&type=script&lang=js&"
export * from "./addText.vue?vue&type=script&lang=js&"
import style0 from "./addText.vue?vue&type=style&index=0&id=09ca91ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca91ac",
  null
  
)

export default component.exports